import { Component, OnInit } from '@angular/core';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmailService } from 'src/app/services/email-service';

@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent implements OnInit {
  currentDate:any;
  constructor(public dialog: MatDialog, public emailService: EmailService,private dialogRef: MatDialogRef<ConsentFormComponent>) { }

  ngOnInit(): void {
    const today = new Date();
    this.currentDate = today.toLocaleDateString();
    console.log(this.currentDate) 
  }
  openPrivacyPolicy(){
    this.dialog.open(PrivacyPolicyComponent, {
      width: '50%',
      height: '70% !important',
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data:'comment',
      autoFocus: false
    });
  }
  openMailOutlook(){
    this.dialogRef.close(true); 
    this.emailService.isPolicyAgreed= true;
    
      // this.emailService
      //   .sendEmail('usha.moosapeta@dataunveil.com', 'Test Subject', 'This is the mail body.')
      //   .then(() => alert('Email sent successfully!'))
      //   .catch((error) => alert('Failed to send email: ' + error.message));
  }
  closePopup(): void {
    this.dialogRef.close(); // Closes the current popup
  }
}
